;(function ($) {
  $(() => {
    $.getUrlParameter = function getUrlParameter(sParam) {
      const sPageURL = decodeURIComponent(window.location.search.substring(1))
      const sURLVariables = sPageURL.split('&')
      let sParameterName
      let i
      for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=')
        if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? true : sParameterName[1]
        }
      }
    }

    $.updateQueryString = function updateQueryString(key, value) {
      if (history.pushState) {
        const searchParams = new URLSearchParams(window.location.search)
        searchParams.set(key, value)
        const newurl = `${window.location.protocol}//${window.location.host}${
          window.location.pathname
        }?${searchParams.toString()}`
        window.history.pushState({ path: newurl }, '', newurl)
      }
    }

    $.updateCategoryURL = function updateCategoryURL(category) {
      if (history.pushState) {
        // Get URL query parameters
        const urlParams = new URLSearchParams(window.location.search)

        // Split the current path into segments
        const pathSegments = window.location.pathname
          .split('/')
          .filter((segment) => segment !== '')

        // Find the index of 'articles-videos' to keep the base path
        const baseIndex = pathSegments.indexOf('articles-videos')

        // Create a new path with base and the new category
        const newPathSegments = pathSegments
          .slice(0, baseIndex + 1)
          .concat(category)

        // Construct the new URL path
        const newPath = `/${newPathSegments.join('/')}`

        // Construct the full new URL
        const newUrl = `${window.location.protocol}//${window.location.host}${newPath}`

        // If there are query parameters, append them to the new URL
        if (urlParams.toString()) {
          const finalUrl = `${newUrl}?${urlParams.toString()}`
          window.history.pushState({ path: finalUrl }, '', finalUrl)
        } else {
          // If no query parameters, just use the new URL with category
          window.history.pushState({ path: newUrl }, '', newUrl)
        }
      }
    }

    $.validateEmail = function validateEmail(email) {
      const re =
        /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
      return re.test(String(email).toLowerCase())
    }
  })
})(jQuery)
